import { render, staticRenderFns } from "./NewItemButton.vue?vue&type=template&id=07f162b4&"
import script from "./NewItemButton.vue?vue&type=script&lang=ts&"
export * from "./NewItemButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports